import navbarComponent  from './navabar.component';
import bookingService from "../booking/booking.service";
import {uploadedVehiclesModule} from "../uploadedVehicles/uploadedVehicles";

const NavbarModule = angular
    .module('navbar', [
      uploadedVehiclesModule.name
    ])
    .service('$bookings', bookingService)
    .component('navbar', navbarComponent);

export default NavbarModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/navbar/navbar.js
 **/